export const getTokenToLocalStorage = () => {
  const token = localStorage.getItem("@flexgr-validacao-facial:token");
  return token ? JSON.parse(token) : null;
};

export const getHashToLocalStorage = () => {
  const hash = localStorage.getItem("@flexgr-validacao-facial:hash");
  return hash ? JSON.parse(hash) : null;
};

export const getCoordsToLocalStorage = () => {
  const coords = localStorage.getItem("@flexgr-validacao-facial:coordenadas");
  return coords ? JSON.parse(coords) : null;
};

export const deleteAllLocalStorage = () => {
  localStorage.clear();
};
